var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 47,
    viewBox: "0 0 180 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.6 33.5644C125.008 34.0249 124.966 34.729 124.505 35.1368L124.23 35.3798C123.769 35.7876 123.064 35.7452 122.656 35.2847L116.067 27.8552L114.246 29.4242V34.548C114.246 35.1634 113.747 35.6619 113.131 35.6619H112.765C112.149 35.6619 111.649 35.1634 111.649 34.548V12.1873C111.649 11.5719 112.149 11.0735 112.765 11.0735H113.131C113.747 11.0735 114.246 11.5719 114.246 12.1873V25.9989L115.331 25.0635L116.301 24.2061L116.312 24.2189L122.903 18.5408C123.369 18.1395 124.074 18.1913 124.476 18.6572L124.715 18.9343C125.117 19.3998 125.065 20.1034 124.599 20.5052L118.034 26.1606L124.6 33.5644ZM76.0097 33.0669H72.7542C71.0438 33.0669 69.6528 31.677 69.6528 29.969V23.9492C69.6528 22.2413 71.0438 20.8518 72.7542 20.8518H80.7717V30.0686C80.7717 32.6917 77.5449 33.0669 76.0097 33.0669ZM82.2531 11.0735H81.8873C81.2712 11.0735 80.7717 11.5719 80.7717 12.1873V18.2583H72.7542C69.6123 18.2583 67.0563 20.8114 67.0563 23.9492V29.969C67.0563 33.1073 69.6123 35.6604 72.7542 35.6604H76.0097C77.8257 35.6604 79.4868 34.9967 80.7717 33.9036V34.548C80.7717 35.1634 81.2712 35.6619 81.8873 35.6619H82.2531C82.8691 35.6619 83.3682 35.1634 83.3682 34.548V28.3098V18.2583V12.1873C83.3682 11.5719 82.8691 11.0735 82.2531 11.0735ZM103.069 29.969C103.069 31.677 101.677 33.0669 99.9673 33.0669H95.0508C93.3404 33.0669 91.9494 31.677 91.9494 29.969V23.9492C91.9494 22.2413 93.3404 20.8518 95.0508 20.8518H99.9673C101.677 20.8518 103.069 22.2413 103.069 23.9492V29.969ZM99.9673 18.2583H95.0508C91.9089 18.2583 89.3529 20.8114 89.3529 23.9492V29.969C89.3529 33.1073 91.9089 35.6604 95.0508 35.6604H99.9673C103.109 35.6604 105.665 33.1073 105.665 29.969V23.9492C105.665 20.8114 103.109 18.2583 99.9673 18.2583ZM36.1785 29.969C36.1785 31.677 34.787 33.0669 33.077 33.0669H28.1605C26.4501 33.0669 25.0591 31.677 25.0591 29.969V23.9492C25.0591 22.2413 26.4501 20.8518 28.1605 20.8518H33.077C34.787 20.8518 36.1785 22.2413 36.1785 23.9492V29.969ZM33.077 18.2583H28.1605C25.0186 18.2583 22.4626 20.8114 22.4626 23.9492V29.969C22.4626 33.1073 25.0186 35.6604 28.1605 35.6604H33.077C36.219 35.6604 38.775 33.1073 38.775 29.969V23.9492C38.775 20.8114 36.219 18.2583 33.077 18.2583ZM16.4784 23.9295V34.548C16.4784 35.1634 15.9788 35.6619 15.3628 35.6619H14.997C14.381 35.6619 13.8819 35.1634 13.8819 34.548V23.9295C13.8819 22.2294 12.5022 20.8518 10.8002 20.8518H8.27183C5.22616 20.8518 3.10801 22.084 3.10801 23.2816V34.548C3.10801 35.1634 2.60846 35.6619 1.99241 35.6619H1.62664C1.01059 35.6619 0.511536 35.1634 0.511536 34.548V19.383C0.511536 18.7682 1.01059 18.2692 1.62664 18.2692H1.99241C2.60846 18.2692 3.10801 18.7682 3.10801 19.383V20.4529C3.4259 20.127 3.83315 19.7779 4.24039 19.452C5.09683 18.7677 6.84081 18.2583 8.27183 18.2583H10.8002C13.9362 18.2583 16.4784 20.7971 16.4784 23.9295ZM53.7126 33.0669H50.4571C48.7472 33.0669 47.3557 31.677 47.3557 29.969V23.9492C47.3557 22.2413 48.7472 20.8518 50.4571 20.8518H58.4751V30.0686C58.4751 32.6917 55.2478 33.0669 53.7126 33.0669ZM59.9565 11.0735H59.5902C58.9746 11.0735 58.4751 11.5719 58.4751 12.1873V18.2583H50.4571C47.3157 18.2583 44.7592 20.8114 44.7592 23.9492V29.969C44.7592 33.1073 47.3157 35.6604 50.4571 35.6604H53.7126C55.5286 35.6604 57.1902 34.9967 58.4751 33.9036V34.548C58.4751 35.1634 58.9746 35.6619 59.5902 35.6619H59.9565C60.5725 35.6619 61.0716 35.1634 61.0716 34.548V28.3098V18.2583V12.1873C61.0716 11.5719 60.5725 11.0735 59.9565 11.0735Z",
    fill: "#E9E6EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_14042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 17,
    width: 12,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.983 17.4999C152.256 17.4999 150.874 18.8804 150.874 20.6062V26.6215C150.874 28.3472 152.256 29.7278 153.983 29.7278H158.87C160.598 29.7278 161.98 28.3472 161.98 26.6215V20.6062C161.98 18.8804 160.598 17.4999 158.87 17.4999H153.983Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-440.688 406.426H507.074V-126.079H-440.688V406.426Z",
    fill: "url(#paint0_radial_18_14042)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.419 8.74007L162.618 9.97864L161.383 3.78186L156.419 8.74007Z",
    fill: "#3B237B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.418 38.4952L150.219 37.2566L151.454 43.4534L156.418 38.4952Z",
    fill: "#3B237B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.559 18.6582L142.765 17.4187L141.524 23.6174L136.559 18.6582Z",
    fill: "#3B237B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.278 28.5764L170.072 29.8159L171.313 23.6172L176.278 28.5764Z",
    fill: "#3B237B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18_14042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 8,
    width: 24,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.296 28.5936L178.271 26.572C179.9 24.9449 179.9 22.2824 178.271 20.6553L170.866 13.2594C169.534 11.9282 167.855 11.0406 166.029 10.6462L156.403 8.72327L176.296 28.5936Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-707.158 146.981L45.3121 879.608L773.546 133.365L21.0765 -599.262L-707.158 146.981Z",
    fill: "url(#paint1_linear_18_14042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_18_14042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 0,
    width: 26,
    height: 19
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.439 1.7711L136.557 18.6338L146.183 16.7601C148.01 16.3657 149.688 15.4782 150.971 14.1469L161.387 3.79265L159.363 1.7711C158.573 0.982206 157.487 0.538452 156.401 0.538452C155.365 0.538452 154.279 0.982206 153.439 1.7711Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_18_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3149 879.735L773.616 137.295L28.0692 -599.389L-707.232 143.051L38.3149 879.735Z",
    fill: "url(#paint2_linear_18_14042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_18_14042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 18,
    width: 24,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.534 20.6555C132.905 22.2826 132.905 24.9451 134.534 26.5722L141.988 34.0174C143.32 35.2993 144.999 36.1868 146.825 36.5813L156.402 38.5042L136.558 18.6339L134.534 20.6555Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_18_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.628 138.804L30.7561 -599.41L-707.243 141.542L35.629 879.757L773.628 138.804Z",
    fill: "url(#paint3_linear_18_14042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_18_14042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 28,
    width: 26,
    height: 19
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.671 30.5167C164.844 30.8618 163.166 31.7493 161.833 33.0806L151.467 43.4348L153.491 45.4564C155.12 47.0835 157.736 47.0835 159.365 45.4564L176.296 28.5938L166.671 30.5167Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_18_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6536 -599.357L-707.211 144.411L40.7362 879.704L773.601 135.936L25.6536 -599.357Z",
    fill: "url(#paint4_linear_18_14042)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_14042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.288 23.4587) scale(10.3134 10.3016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159524,
    stopColor: "#EB1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313095,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446429,
    stopColor: "#D01253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57619,
    stopColor: "#B70F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70119,
    stopColor: "#960C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811905,
    stopColor: "#710848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919048,
    stopColor: "#460443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21003F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_14042",
    x1: 152.026,
    y1: 2.9385,
    x2: 176.978,
    y2: 27.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_14042",
    x1: 134.121,
    y1: 24.5983,
    x2: 157.308,
    y2: 1.13277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_14042",
    x1: 160.356,
    y1: 44.1671,
    x2: 135.783,
    y2: 19.6918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18_14042",
    x1: 179.323,
    y1: 22.1503,
    x2: 155.758,
    y2: 46.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f264432b176af2b670ea1a74ac747c88.svg";
export { ForwardRef as ReactComponent };